import * as React from 'react';

import { INewbuildingSectionProps } from '../../../common/utils/types';
import { useSelector } from 'react-redux';
import { selectFormFields, selectNewbuildingName } from '../../selectors';
import { useActions } from '../useActions';
import { ECurrentErrorField } from '../../types/formFields';

export const useNewbuildingSectionProps = (): INewbuildingSectionProps => {
  const newbuildingName = useSelector(selectNewbuildingName);
  const { newbuildingSection, newbuildingSectionsList, errorTooltip } = useSelector(selectFormFields);

  const { setNewbuildingSection } = useActions();

  const errorMessage = errorTooltip.currentErrorField === ECurrentErrorField.section ? errorTooltip.errorText : '';

  const onItemChange = React.useCallback<INewbuildingSectionProps['onItemChange']>(
    value => {
      setNewbuildingSection(value);
    },
    [setNewbuildingSection],
  );

  return {
    newbuildingName,
    selectedSection: newbuildingSection,
    newbuildingSections: newbuildingSectionsList ?? [],
    onItemChange,
    errorMessage,
  };
};
